/** 인라인 폼 에러 텍스트. children 이 없으면 렌더하지 않음. */
export function ErrorText({ children }: { children?: React.ReactNode }) {
  if (!children) return null;
  return (
    <p className="text-sm" style={{ color: "var(--danger)" }}>
      {children}
    </p>
  );
}
